import axios from 'axios';
import { isBlank } from '../../libs/strings';
import DocImage from '../../../assets/images/fileicons/doc.svg';
import FileImage from '../../../assets/images/fileicons/file.svg';
import CsvImage from '../../../assets/images/fileicons/csv.svg';
import ExcelImage from '../../../assets/images/fileicons/excel.svg';
import PdfImage from '../../../assets/images/fileicons/pdf.svg';
import TxtImage from '../../../assets/images/fileicons/txt.svg';
import PptImage from '../../../assets/images/fileicons/ppt.svg';
import ZipImage from '../../../assets/images/fileicons/zip.svg';

const LIBRARY_UPLOAD_FILES_PATH = '/library_upload';
const LIBRARY_UPLOADED_FILES_PATH = '/library_uploaded_files';

export function getUrlIconoNoImagen(contentType) {
  let icono;
  switch (contentType) {
    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    case 'application/vnd.oasis.opendocument.text':
    case 'application/msword':
      icono = DocImage;
      break;
    case 'text/csv':
      icono = CsvImage;
      break;
    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    case 'application/vnd.ms-excel':
    case 'application/vnd.oasis.opendocument.spreadsheet':
      icono = ExcelImage;
      break;
    case 'application/pdf':
      icono = PdfImage;
      break;
    case 'text/plain':
      icono = TxtImage;
      break;
    case 'application/vnd.oasis.opendocument.presentation':
    case 'application/vnd.ms-powerpoint':
    case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      icono = PptImage;
      break;
    case 'application/zip':
    case 'application/x-zip-compressed':
    case 'multipart/x-zip':
      icono = ZipImage;
      break;
    default:
      icono = FileImage;
  }
  return icono;
}

export default {
  destroy(modelo, id, asociacion) {
    let url;
    url = `/library_destroy/${id}/${modelo}`;

    if (asociacion) { url = `${url}/${asociacion}`; }

    return axios.delete(url);
  },
  getArchivosActuales(modelo, id, asociacion) {
    let url;
    if (isBlank(id)) {
      url = `${LIBRARY_UPLOADED_FILES_PATH}/new/${modelo}`;
    }
    url = `${LIBRARY_UPLOADED_FILES_PATH}/${id}/${modelo}`;

    if (asociacion) { url = `${url}/${asociacion}`; }

    return axios.get(url);
  },
  getUrlUpload(modelo, id, asociacion) {
    // Si no tengo modelId es que estoy con el dropzone en un new
    if (isBlank(id)) {
      return `${LIBRARY_UPLOAD_FILES_PATH}/new/${modelo}`;
    }

    let url = `${LIBRARY_UPLOAD_FILES_PATH}/${id}/${modelo}`;

    if (asociacion) { url = `${url}/${asociacion}`; }

    return url;
  },
  // idsAdjuntosOrdenados debe ser un array de ids de los adjuntos
  ordenar(modelo, id, idsAdjuntosOrdenados) {
    // El servidor lo espera como un único parámetro separados por comas...
    const ficheros = idsAdjuntosOrdenados.join(',');
    return axios.post(`/library_sort/${id}/${modelo}`, { ficheros });
  },
};
